import { ReactNode } from 'react';

import { ProductKeys } from '@atlassiansox/asc-stargate';

import { SiteSelectorContextProvider } from '@/components/site-selector-modal/site-selector-context';
import { GlobalFooter } from '@/patterns/global-footer/src/global-footer';
import JiraServiceManagementSoftwareNavV2 from '@/templates/software/jira/service-management/jira-service-management-software-page/src/sections/software-jira-service-management-navbarv2';

export const SharedHeaderFooterContainer = ({ children }: { children: ReactNode }) => {
	return (
		<>
			<JiraServiceManagementSoftwareNavV2 />
			<SiteSelectorContextProvider
				productKey={ProductKeys.JIRA_SERVICE_DESK}
				analyticsPrefix="wac.showroom"
				internalLinkAfterIdentity="/team-playbook/plays/choose-your-site"
			>
				{children}
			</SiteSelectorContextProvider>
			<GlobalFooter />
		</>
	);
};
